import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          {/* Left Content */}
          <div className="w-full lg:w-[55%] order-2 lg:order-1">
            <p className="text-sm font-semibold text-primary-500 tracking-widest uppercase mb-3">
              PandabuySpreadsheet SEO Guide
            </p>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-6 leading-tight">
              Master Product Comparison
              <br />
              <span className="text-foreground-500">with Spreadsheet Intelligence</span>
            </h2>

            <div className="space-y-5 text-foreground-600 leading-relaxed text-sm md:text-base">
              <p>
                In the modern online shopping landscape, making informed decisions requires more than
                just browsing product listings. The PandabuySpreadsheet methodology revolutionizes how
                shoppers approach product research by introducing structured data comparison into the
                decision-making process. Rather than relying on scattered reviews and gut feelings,
                users can leverage organized spreadsheet data to evaluate products systematically.
              </p>
              <p>
                Our product comparison spreadsheet system covers an extensive range of categories
                including Shoes, Hoodies and Sweaters, T-Shirts, Jackets, Pants and Shorts, Headwear,
                Sets, Underwear, Jerseys, Accessories, Bags, Belts, Perfumes, and more. Each category
                features curated product data designed to help you find the best value quickly. The
                spreadsheet format makes it effortless to sort, filter, and compare options side by side.
              </p>
              <p>
                Whether you are hunting for the latest sneaker deals or searching for premium hoodie
                alternatives, the PandabuySpreadsheet approach saves hours of manual research. Start
                your smart shopping journey by exploring our{' '}
                <Link
                  to="/"
                  className="text-primary-500 hover:text-primary-600 font-medium underline underline-offset-2"
                >
                  homepage categories
                </Link>{' '}
                or dive into our detailed{' '}
                <Link
                  to="/blog/pandabuy-spreadsheet-comparison-guide"
                  className="text-primary-500 hover:text-primary-600 font-medium underline underline-offset-2"
                >
                  comparison guide
                </Link>{' '}
                for a complete walkthrough of the data-driven shopping methodology.
              </p>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row gap-3">
              <Link
                to="/blog/pandabuy-spreadsheet-comparison-guide"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Read Full Guide
                <i className="ri-arrow-right-line"></i>
              </Link>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border-2 border-foreground-200 text-foreground-700 font-semibold text-sm hover:border-foreground-400 hover:text-foreground-950 transition-colors whitespace-nowrap cursor-pointer"
              >
                Pandabuy Sheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>

            <p className="mt-6 text-xs text-foreground-400 italic">
              &mdash; PandabuySpreadsheet Editorial Team
            </p>
          </div>

          {/* Right Image */}
          <div className="w-full lg:w-[45%] order-1 lg:order-2">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] bg-background-100">
              <img
                src="https://readdy.ai/api/search-image?query=Vertical%20editorial%20photography%20of%20a%20beautifully%20styled%20shelf%20with%20curated%20fashion%20accessories%2C%20a%20small%20plant%2C%20folded%20neutral%20tone%20garments%2C%20and%20a%20tablet%20displaying%20comparison%20data%2C%20warm%20terracotta%20and%20cream%20palette%2C%20soft%20afternoon%20sunlight%2C%20calm%20sophisticated%20atmosphere%2C%20no%20text%2C%20premium%20lifestyle%20photography&width=700&height=875&seq=seo-content-v3&orientation=portrait"
                alt="PandabuySpreadsheet product comparison methodology"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}